"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const _Portal_1 = require("../_Portal");
const calculatePosition_1 = require("./utils/calculatePosition");
// styles
require("./floatingContent.scss");
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-floatingContent",
    position: "bottom-left",
    action: "click",
    parentElement: undefined,
};
const FloatingContent = (_a) => {
    var { trigger, children, className, onToggle, action, isShown, position, triggerClassName, parentElement, id, style } = _a, rest = __rest(_a, ["trigger", "children", "className", "onToggle", "action", "isShown", "position", "triggerClassName", "parentElement", "id", "style"]);
    const classList = (0, classnames_1.default)("tecma-floatingContent-container", { [`${position}`]: position }, className);
    const triggerClassList = (0, classnames_1.default)("floatingContent-trigger", triggerClassName);
    const triggerRef = (0, react_1.useRef)(null);
    const floatingContentRef = (0, react_1.useRef)(null);
    const [nextStyle, setNextStyle] = (0, react_1.useState)();
    const [mouseIsHovering, setMouseHover] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (triggerRef.current && position && floatingContentRef.current && isShown) {
            const triggerPosition = triggerRef.current.getBoundingClientRect();
            const triggerParentValues = parentElement === null || parentElement === void 0 ? void 0 : parentElement.getBoundingClientRect();
            const floatingContentPosition = floatingContentRef.current.getBoundingClientRect();
            setNextStyle((0, calculatePosition_1.calculatePosition)(triggerPosition, floatingContentPosition, position, triggerParentValues));
        }
    }, [isShown, position]);
    /**
     * onMouseEnter and onMouseLeave functions are both used to handle the hover action by toggling the
     * mouseIsHovering state and firing the onToggle callback
     */
    const onMouseEnter = () => {
        if (!mouseIsHovering) {
            setMouseHover(true);
            onToggle();
        }
    };
    const onMouseLeave = () => {
        if (mouseIsHovering) {
            setMouseHover(false);
            onToggle();
        }
    };
    const actions = {
        onClick: action === "click" ? onToggle : undefined,
        onMouseEnter: action === "hover" ? onMouseEnter : undefined,
        onMouseLeave: action === "hover" ? onMouseLeave : undefined,
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ ref: triggerRef, className: triggerClassList }, rest, actions, { children: trigger })), isShown && ((0, jsx_runtime_1.jsx)(_Portal_1.Portal, Object.assign({ id: "tecma-floatingContent" }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: classList, style: Object.assign(Object.assign({}, style), nextStyle), id: id, ref: floatingContentRef }, { children: children })) })))] }));
};
FloatingContent.defaultProps = defaultProps;
exports.default = react_1.default.memo(FloatingContent);
